import {Component} from 'react';
import {connect} from 'react-redux';
import {getTimestamp} from '../utils';


class AudioRecorder extends Component {
    constructor(props) {
        super(props)
        this.clearIt = this.clearIt.bind(this)
    }

    clearIt() {
        this.it && clearTimeout(this.it)
        this.startIt && clearTimeout(this.startIt)
    }

    componentWillUpdate(nextProps, nextState) {
        const {audioRecorder} = nextProps
        if (!audioRecorder.wxReady || audioRecorder.platform !== 'wechat')
            return;
        if (this.props.audioRecorder.recorderState === nextProps.audioRecorder.recorderState)
            return;

        // 清除定时器
        this.clearIt()

        if (audioRecorder.recorderState === 'check') {
            const statusStr = localStorage.getItem('audioRecorder/status');
            if (statusStr) {
                const status = JSON.parse(statusStr);
                /* 7天无需再检查权限 */
                if (status.checked && (Date.now() - status.checkTime) < 1000 * 86400 * 7) {
                    this.props.dispatch({
                        type: 'RECORDER_SET_READY'
                    });
                    return;
                }
            }
            /* 尝试获取录音权限，可避免真正录音时弹出获取权限 */
            window.wx.startRecord({
                success: () => {
                    this.it = setTimeout(() => {
                        window.wx.stopRecord({
                            complete: (res) => {
                                this.props.dispatch({
                                    type: 'RECORDER_SET_READY'
                                });
                                localStorage.setItem('audioRecorder/status', JSON.stringify({
                                    checked: true,
                                    checkTime: Date.now()
                                }));
                            }
                        });
                    }, 500);
                }
            });
        }
        if (audioRecorder.recorderState === 'start') {
            // 避免按下按钮界面卡，这里放一个定时器
            this.startIt = setTimeout(() => {
                let completed = false
                window.wx.startRecord({  
                    success: () => {
                        this.props.dispatch({
                            type: 'RECORDER_SET_RECORDING'
                        })
                        completed = true
                    }, fail: () => {
                        window.wx.stopRecord()
                        this.props.dispatch({
                            type: 'RECORDER_SET_READY'
                        })
                        completed = true
                    }
                })
                this.it = setTimeout(() => {
                    if (!completed) {
                        this.props.dispatch({
                            type: 'RECORDER_SET_READY'
                        })
                        alert('录音已中断，通常是因为手机锁屏或网络断开引起，请保持手机亮屏和网络畅通。')
                    }
                }, 5000)
            }, 100)
        }
        if (audioRecorder.recorderState === 'stop') {
            var wait = 10;
            if ((Date.now() - audioRecorder.startRecordTime) < 500) {
                wait = 300;
            }
            this.startIt = setTimeout(() => {
                window.wx.stopRecord({
                    complete: (res) => {
                        if (res.localId) {
                            const duration = Math.floor((Date.now() - audioRecorder.startRecordTime) / 1000);
                            const {timestampDelta} = this.props;
                            let timestamp = getTimestamp(timestampDelta);
                            this.props.dispatch({
                                type: 'ML_SEND_MESSAGE',
                                payload: {
                                    type: 'voice',
                                    account: this.props.account,
                                    local_id: res.localId,
                                    length: duration,
                                    reply: this.props.reply,
                                    from: 'weixinhd',
                                    timestamp: timestamp,
                                }
                            })
                            if (this.props.reply) {
                                this.props.dispatch({
                                    type: 'CLASSROOM_SET_REPLY',
                                    payload: null
                                })
                            }
                        }
                        if (audioRecorder.autoRecordNext) {
                            this.it = setTimeout(() => {
                                // 开启下一条录音
                                this.props.dispatch({
                                    type: 'RECORDER_START_RECORD'
                                });
                            }, 50)
                        } else {
                            this.props.dispatch({
                                'type': 'RECORDER_SET_READY'
                            });
                        }
                    }
                });
            }, wait);
        }
        if (audioRecorder.recorderState === 'force_stop') {
            if (audioRecorder.localId) {
                const duration = Math.floor((Date.now() - audioRecorder.startRecordTime) / 1000);
                const {timestampDelta} = this.props;
                let timestamp = getTimestamp(timestampDelta);
                this.props.dispatch({
                    type: 'ML_SEND_MESSAGE',
                    payload: {
                        type: 'voice',
                        account: this.props.account,
                        local_id: audioRecorder.localId,
                        length: duration,
                        reply: this.props.reply,
                        from: 'weixinhd',
                        timestamp: timestamp
                    }
                })
                if (this.props.reply) {
                    this.props.dispatch({
                        type: 'CLASSROOM_SET_REPLY',
                        payload: null
                    })
                }
            }
            this.it = setTimeout(() => {
                // 开启下一条录音
                this.props.dispatch({
                    type: 'RECORDER_START_RECORD'
                });
            }, 50)
        }
        if (audioRecorder.recorderState === 'cancel') {
            var wait2 = 10;
            if ((Date.now() - audioRecorder.startRecordTime) < 500) {
                wait2 = 300;
            }
            this.it = setTimeout(() => {
                window.wx.stopRecord({
                    complete: (res) => {
                        this.props.dispatch({
                            'type': 'RECORDER_SET_READY'
                        });
                    }
                });
            }, wait2);
        }
    }

    render() {
        return null;
    }
}


export default connect((state) => ({
    audioRecorder: state.audioRecorder,
    account: state.account,
    reply: state.classroom.reply,
    timestampDelta: state.classroom.timestampDelta,
}))(AudioRecorder);




// WEBPACK FOOTER //
// ./src/components/AudioRecorder.js